import { render } from "./SelectItemModal.vue?vue&type=template&id=23731db8&lang=pug"
import script from "./SelectItemModal.vue?vue&type=script&lang=js"
export * from "./SelectItemModal.vue?vue&type=script&lang=js"

import "./SelectItemModal.vue?vue&type=style&index=0&id=23731db8&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QScrollArea});
